var globals = {
  REACT_APP_URL_BASE_API: process.env.REACT_APP_URL_BASE_API,
  REACT_APP_URL_BASE_API_STORAGE: process.env.REACT_APP_URL_BASE_API_STORAGE,
  REACT_APP_AZURE_URL_BLOB: process.env.REACT_APP_AZURE_URL_BLOB,
  REACT_APP_AZURE_CONNECTION_STRING: process.env.REACT_APP_AZURE_CONNECTION_STRING,
  REACT_APP_MIDIA_COOPERADA_LINK: process.env.REACT_APP_MIDIA_COOPERADA_LINK,
};
export default globals;
